export default __webpack_public_path__ + "static/media/Template10.7c02a96e.jpg";